import type { DeliveryAddressCookieData } from "~/features/delivery-address/delivery-address.cookie";

export const APPLY_DELIVERY_ADDRESS_EVENT = "dransay:apply-delivery-address";

export function applyDeliveryAddress(address: DeliveryAddressCookieData): void {
	window.dispatchEvent(
		new CustomEvent(APPLY_DELIVERY_ADDRESS_EVENT, { detail: address }),
	);
}
